var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row space-x-3"},[_c('span',{staticClass:"text-wizBlue"},[_vm._v("•")]),_c('p',{staticClass:"max-w-md text-xs",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }